import React, { useCallback } from "react"
import * as AppConstants from "../../../utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"

function BodyTable(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_NUMERO_POSIZIONI}{" "}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.numPosizioni
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.numPosizioni
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.numPosizioni
                        : elemNonDisponibile}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th>{AppConstants.DATI_NUMERO_ADDETTI}</th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.numAddetti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.numAddetti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.numAddetti
                        : elemNonDisponibile}
                </td>
            </tr>

            <tr className="tableStatIsa">
                <th>{AppConstants.DATI_PUNTEGGIO_AFFID_TOT}</th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.punteggioIsa
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.punteggioIsa
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.punteggioIsa
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th> {AppConstants.DATI_REDDITO_MEDIO} </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.redditoMedio
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {props.campo2 !== undefined
                            ? props.campo2.redditoMedio
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.redditoMedio
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th> {AppConstants.DATI_ULTERIORI_COMP_POS} </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.adeguamenti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {props.campo2 !== undefined
                            ? props.campo2.adeguamenti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.adeguamenti
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
        </React.Fragment>
    )
}
export default BodyTable
